module.exports = __webpack_public_path__ + "img/email_o.80a03206.svg";